export default __webpack_public_path__ + "static/media/img_8.bf3ac504.jpg";